import React from "react";
import { AlertTriangle } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

export function DisclaimerBanner({ compact = false }) {
  const { t } = useLang();
  return (
    <div
      data-testid="disclaimer-banner"
      className={`flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 ${compact ? "p-3" : "p-4"} text-amber-900`}
    >
      <AlertTriangle className="w-5 h-5 mt-0.5 shrink-0 text-amber-600" />
      <p className="text-sm leading-relaxed">
        <strong className="font-semibold">{t("advisory")}</strong> {t("disclaimer_short")} {t("advisory_tail")}
      </p>
    </div>
  );
}
